// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1BtA8","log":"ModalInventoryLogs_log__2mmgY","date":"ModalInventoryLogs_date__ubdeR","userName":"ModalInventoryLogs_userName__1zC5y"};